import { render, staticRenderFns } from "./SurveyInput.vue?vue&type=template&id=473df1c3&scoped=true"
import script from "./SurveyInput.vue?vue&type=script&lang=js"
export * from "./SurveyInput.vue?vue&type=script&lang=js"
import style0 from "./SurveyInput.vue?vue&type=style&index=0&id=473df1c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473df1c3",
  null
  
)

export default component.exports